<template>
  <div id="app">
    <!-- <header class="mb-4"> -->
    <TheNavigation />

    <Header v-if="false" />
    <Header2 />

    <!--
      Этот key нужен, чтобы убрать глюк, когда в пути меняется только парамтер, 
      и путь в адресной строке меняется, а страница не перезагружается.
      см. fooobar . com/questions/15987837/vue-router-not-firing-if-only-slug-changes
    -->
    <!-- <div class="container app-container px-5 pb-5 border-left border-right"> -->
    <div class="container app-container px-5 pb-5 ">
      <router-view :key="$route.fullPath" />
    </div>

    <TheFooter />
  </div>
</template>

<script>
global.jQuery = require("jquery");
var $ = global.jQuery;
var jQuery = global.jQuery;
window.$ = $;
window.jQuery = jQuery;

//var funcNames = ["log", "warn", "error", "info"];
//var colors = ['color:green', 'color:orange', 'color:red', 'background-color:green'];
/*
  если нигде не аукнется, то грохнуть!!!
var funcNames = ["info"];
var colors = ['background-color:green'];
for (var i = 0; i < funcNames.length; i++) {
    let funcName = funcNames[i];
    let color = colors[i];
    let oldFunc = console[funcName];
    console[funcName] = function () {
        var args = Array.prototype.slice.call(arguments);
        if (args.length) args = ['%c' + args[0]].concat(color, args.slice(1));
        oldFunc.apply(null, args);
    };
}
*/

import TheNavigation from "@/components/TheNavigation4";
import Header from "@/components/Header";
import Header2 from "@/components/Header2";

import TheFooter from "@/components/Footer";

export default {
  components: {
    TheNavigation,
    TheFooter,
    Header,
    Header2,
  },
};
</script>

<style scoped>
.app-container {
  /* background: #fff;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1); */
}
</style>


